import type { ViewportItem } from '@/hooks/useGetAvatarsViewport';

export type ViewportItemStack = {
    key: string;
    lat: number;
    lng: number;
    items: ViewportItem[];
};

/**
 * Groups viewport items that share the same coordinates (after rounding).
 */
export function groupViewportItemsByPosition(items: ViewportItem[], decimals = 6): ViewportItemStack[] {
    const buckets = new Map<string, ViewportItem[]>();
    const factor = 10 ** decimals;

    for (const item of items) {
        const rlat = Math.round(item.lat * factor) / factor;
        const rlng = Math.round(item.lng * factor) / factor;
        const key = `${rlat},${rlng}`;
        const list = buckets.get(key);
        if (list) list.push(item);
        else buckets.set(key, [item]);
    }

    return Array.from(buckets.entries()).map(([key, groupItems]) => ({
        key,
        lat: groupItems[0].lat,
        lng: groupItems[0].lng,
        items: groupItems,
    }));
}
